import { Box, Typography } from '@mui/material';
import { Iconify, NextImage } from '@sdf/base';
import { Styles } from '@t2c/shared-fe';
import { ContentType } from 'apps/t2c-fe/utils';
import React from 'react';

const EmptyPage = ({
  minimumHeight,
  text,
  type,
}: {
  minimumHeight?: string;
  text: string;
  type: ContentType;
}) => {
  const contentImages = {
    [ContentType.Audio]: '/assets/NoAudioFound.svg',
    [ContentType.Video]: '/assets/NoVideoFound.svg',
    [ContentType.Avatar]: '/assets/NoAvatarFound.svg',
    [ContentType.ContentDraft]: '/assets/NoContentFound.svg',
  };
  const imageSrc = contentImages[type];

  return (
    <Box
      minHeight={minimumHeight ? minimumHeight : '40vh'}
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
      flexDirection={'column'}
    >
      {imageSrc && (
        <img
          src={imageSrc}
          style={{ mixBlendMode: 'hard-light' }}
          alt="logo"
          width={533}
          height={277}
        />
      )}

      {/* <Box>
        <Iconify icon={'icomoon-free:files-empty'} color={'GrayText'} fontSize={'50px'} />
      </Box> */}
      <Typography variant="body1" fontSize={'16px'} mt={'105px'} sx={styles.imageTxt}>
        {text}
      </Typography>
    </Box>
  );
};

const styles: Styles = {
  imageTxt: {
    position: 'absolute',
    color: (theme) => theme.palette.text.primary,
  },
};

export default EmptyPage;
